export enum VibehutTheme {
  system = "system",
  Light = "light-theme",
  Dark = "dark-theme",
}

export enum archiveType {
  call = "call",
  news = "news",
}

export enum bookingStatusType {
  PENDING = "pending",
  CONFIRMED = "confirmed",
  CANCELLED = "cancelled",
}
